export const MIN_REVENUE_IN_USD = 250_000;
